import { QueryType } from '@/app/types/types'
import { apiClient } from '..'

const bookSlotManuallyRequest = (data: QueryType, requestMethod: 'post' | 'put' = 'post') => {
    if (requestMethod === 'put') {
        return apiClient().put('/api/calendar', data)
    } else {
        return apiClient().post('/api/calendar', data)
    }
}

const sendAllSlotsRequest = (data: QueryType) => {
    return apiClient().post(`/api/calendar/scheduling-slots`, data)
}

const sendCuratedSlotsRequest = (data: QueryType) => {
    return apiClient().post(`/api/calendar/scheduling-slots`, data)
}

const createInterviewRoundRequest = (interviewId: number, data: QueryType) => {
    return apiClient().post(`/api/interviews/${interviewId}/interviewRound`, data)
}

const updateInterviewRoundRequest = (interviewId: number, data: QueryType) => {
    return apiClient().put(`/api/interviews/${interviewId}/interviewRound/${data.id}`, data)
}

const updatePanelistFeedbackRequest = (interviewId: number, data: QueryType) => {
    return apiClient().put(`/api/interviews/${interviewId}/interviewRound`, data)
}

const createInterviewRequest = (data: QueryType) => {
    return apiClient().post(`/api/interviews`, data)
}

const generateInterviewQuestionsRequest = (data: QueryType, params: QueryType) => {
    // Use POST for creating new questions (when interviewId is provided as query param)
    // Use PUT for updating existing questions (when id is provided - use path param)
    if (params.id) {
        // PUT uses path parameter: /api/generateQuestions/[id]
        return apiClient().put(`/api/generateQuestions/${params.id}`, data)
    } else {
        // POST uses query parameter: /api/generateQuestions?interviewId={id}
        return apiClient().post(`/api/generateQuestions`, data, { params })
    }
}

const createBulkScreeningInterviewsRequest = (data: {
    jobApplicationIds: number[]
    companySlug: string
    options?: {
        agentLanguage?: string
        candidateLanguage?: string
        createScreeningRound?: boolean
        generateQuestions?: boolean
        interviewTransport?: 'DAILY_JS' | 'FASTRTC'
    }
}) => {
    return apiClient().post(`/api/interviews/screeningInterview`, data)
}

const startScreeningInterviewRequest = (data: any) => {
    return apiClient().post(`/api/interviews/screeningInterview/start`, data)
}

export {
    bookSlotManuallyRequest,
    updateInterviewRoundRequest,
    updatePanelistFeedbackRequest,
    sendAllSlotsRequest,
    sendCuratedSlotsRequest,
    createInterviewRequest,
    generateInterviewQuestionsRequest,
    createBulkScreeningInterviewsRequest,
    startScreeningInterviewRequest,
    createInterviewRoundRequest,
}
